import React from 'react';
import { connect } from 'react-redux';

import { Button } from '~/eds/src/components/Button/Button';
import { useIntl } from 'react-intl';
import FlexLayout from '~/ui/components/FlexLayout/FlexLayout';
import Text from '~/ui/components/Text/Text';
import { copyToClipboard } from '~/utils/helper.utils';
import { getClientDomainWindowLocation } from '~/utils/user';

function BlankFormLink({ currentUser, intakeFormLinkId }) {
  const intl = useIntl();
  const intakeFormLink = `${getClientDomainWindowLocation(
    currentUser,
  )}/workflow/${intakeFormLinkId}/intake-form/link`;

  function handleCopyAction() {
    copyToClipboard(
      intakeFormLink,
      intl.formatMessage({
        id: 'BlankFormLink.copySuccessMessage',
        defaultMessage: 'Intake form link copied to clipboard',
        description: 'Success message when intake form link is copied',
      }),
    );
  }

  return (
    <>
      <FlexLayout flexDirection="column" space={2}>
        <Text color="gray-600" variant="xs-dense-medium">
          {intl.formatMessage({
            id: 'BlankFormLink.descriptionText',
            defaultMessage:
              'Unique URL for a blank Intake Form. This field will automatically populate with a URL after your workflow is published.',
            description: 'Description for blank form link section',
          })}
        </Text>
      </FlexLayout>

      <FlexLayout
        alignItems="center"
        justifyContent="space-between"
        px={4}
        py={1}
        space={4}
        sx={{
          bg: 'gray-300',
          borderRadius: 'm',
          height: 'input-height',
        }}
      >
        <Text color="gray-700" variant="xs-dense">
          {intakeFormLinkId
            ? intakeFormLink
            : intl.formatMessage({
                id: 'BlankFormLink.placeholderText',
                defaultMessage:
                  'A URL for this workflow will appear when the workflow is published',
                description: 'Placeholder text when workflow is not published',
              })}
        </Text>
        {intakeFormLinkId && (
          <Button
            id="workflow--settings-copy-intake-form-url"
            text={intl.formatMessage({
              id: 'BlankFormLink.copyLinkButton',
              defaultMessage: 'Copy link',
              description: 'Button text for copying the link',
            })}
            variant="action"
            onClick={handleCopyAction}
          />
        )}
      </FlexLayout>
    </>
  );
}

const mapStateToProps = ({ currentUser }) => ({ currentUser });

export default connect(mapStateToProps)(BlankFormLink);
